import { Navigate } from "react-router-dom";
import { useSiteSettingsContext } from "@/contexts/SiteSettingsContext";

interface Props {
  path: string;
  children: React.ReactNode;
}

/** Renders children if the page is visible, otherwise redirects to 404 */
const GuardedPage = ({ path, children }: Props) => {
  const { isPageVisible, loading } = useSiteSettingsContext();

  // While loading, render children to avoid flash of 404
  if (loading) return <>{children}</>;

  if (!isPageVisible(path)) {
    return <Navigate to="/404" replace />;
  }

  return <>{children}</>;
};

export default GuardedPage;
